var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transcoding-progress status-play",on:{"click":_vm.handlePreview}},[_c('PlaySvg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }